import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { isEqual } from 'underscore';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { createReduxHistoryContext } from  'redux-first-history' ;
import { createBrowserHistory } from  'history' ;

import rootReducer from '@/reducers/reducers';
import { getPersistedData } from './storeUtil';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ 
  history : createBrowserHistory(),
});

const middleware = [thunk, routerMiddleware];

const stateAdaption = [
  createTransform(
    state => ({
      ...state,
      chunks: {
        chunkIndex: 0,
        chunks: [],
        activeChunk: []
      },
      deliveries: {
        deliveries: [],
        tuples: [],
        deliveriesById: {}
      }
    }),
    (state, key) => ({
      ...getPersistedData(key, state)
    }),
    { whitelist: ['core', 'jobs', 'login'] }
  )
];

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['jobs', 'sessionStorage', 'core', 'login'],
  stateReconciler: autoMergeLevel2,
  transforms: stateAdaption
};
const persistedReducer = persistReducer(persistConfig, rootReducer(routerReducer));

const configureStore = () => {
  const store = createStore(
    persistedReducer,
    composeWithDevTools(
      applyMiddleware(...middleware)
    )
  );

  const history = createReduxHistory(store);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./../../reducers/reducers', () => {
      store.replaceReducer(rootReducer(history));
    });
  }

  // HANDLE STATE SUBSCRIPTIONS
  let currentState;

  function handleChange () {
    const previousState = currentState;
    currentState = store.getState();
    if (!(isEqual(previousState, currentState))) {
      // /HERE GO THE SUBSCRIPTIONS
    }
  }

  const persistor = persistStore(store);
  store.subscribe(handleChange);

  return { store, persistor, history };
};

export default configureStore;
